module.exports = __webpack_public_path__ + "0458b5dfd575cd15678bbe5229003658.svg";